export enum ReservationIntent {
  Finalize = 0,
  Split = 1,
}
